import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IBeneficiary } from "@pbm/beneficiaries/contracts";
import { IFilteredColumn } from "@funcional/react-table-ui";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { CursorPaginated } from "@types";

export interface BeneficiariesArgsFilterInput {
  id?: string[];
  customerCode?: string[];
  programCode?: string[];
}
interface UseBeneficiariesOptions {
  before?: string;
  after?: string;
  first?: number;
  last?: number;
  filter?: BeneficiariesArgsFilterInput;
  gridFilters?: IFilteredColumn[];
}

export function useBeneficiaries(
  options: UseBeneficiariesOptions | undefined = {}
) {
  const { request } = usePbm2Url();
  if (options.gridFilters) {
    const filter: BeneficiariesArgsFilterInput = options.filter || {};
    options.gridFilters.forEach((filteredColumn: any) => {
      if (filteredColumn.id === "customerCode")
        filter.customerCode = [filteredColumn.value];
      if (filteredColumn.id === "after") options.after = filteredColumn.value;
      if (filteredColumn.id === "before") options.before = filteredColumn.value;
    });

    options.filter = filter;
  }

  if (options.before) {
    options.last = options.last || 10;
  }

  if (!options.before) {
    options.first = options.first || 10;
  }

  return useQuery("beneficiaries:" + JSON.stringify(options), async () => {
    const { Beneficiaries_beneficiaries } = await request(
      gql`
        query Beneficiaries_beneficiaries(
          $before: String
          $after: String
          $first: Int
          $last: Int
          $filter: Beneficiaries_BeneficiariesArgsFilterInput
        ) {
          Beneficiaries_beneficiaries(
            before: $before
            after: $after
            first: $first
            last: $last
            filter: $filter
          ) {
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              pageCount
              totalCount
            }
            edges {
              cursor
              node {
                id
                customerCode
                createdAt
              }
            }
          }
        }
      `,
      options
    );
    return Beneficiaries_beneficiaries as CursorPaginated<IBeneficiary>;
  });
}
